import { smaAt } from "./movingAverages";

/**
 * Population standard deviation of the last `period` values around their
 * mean, as TV Std.stdev (Bollinger Bands).
 *
 * @param {(index: number) => number} read
 * @param {number} index
 * @param {number} period
 * @returns {number} NaN while the window is not full
 */
export const standardDeviationAt = (read, index, period) => {
  const mean = smaAt(read, index, period);

  if (!Number.isFinite(mean)) return NaN;

  let sum = 0;

  for (let position = index - period + 1; position <= index; position += 1) {
    const deviation = read(position) - mean;

    sum += deviation * deviation;
  }

  return Math.sqrt(sum / period);
};

/**
 * Mean absolute deviation of the last `period` values from their mean, as
 * TV Std.dev (CCI).
 *
 * @param {(index: number) => number} read
 * @param {number} index
 * @param {number} period
 * @returns {number} NaN while the window is not full
 */
export const meanDeviationAt = (read, index, period) => {
  const mean = smaAt(read, index, period);

  if (!Number.isFinite(mean)) return NaN;

  let sum = 0;

  for (let position = index - period + 1; position <= index; position += 1) {
    sum += Math.abs(read(position) - mean);
  }

  return sum / period;
};

/**
 * Sum of the last `period` values as TV Std.sum: a missing value (NaN, also
 * before the first bar) counts as zero, so the first sums are partial (Vortex).
 *
 * @param {(index: number) => number} read
 * @param {number} index
 * @param {number} period
 * @returns {number}
 */
export const partialSumAt = (read, index, period) => {
  let sum = 0;

  for (let position = Math.max(0, index - period + 1); position <= index; position += 1) {
    const value = read(position);

    if (Number.isFinite(value)) sum += value;
  }

  return sum;
};
